import React, { Component } from "react";

class Menu extends Component {
	render() {
		const selectedPage = this.props.selected;
		return (
			<div className='row row justify-content-start'>
				<div className={"col-sm-auto shadow " + (selectedPage === "welcome" ? "selected" : "notselected")}>
					<a href="/welcome">Welcome</a>
				</div>
				<div className={"col-sm-auto shadow " + (selectedPage === "about" ? "selected" : "notselected")}>
					<a href="/about">About</a>
				</div>
				<div className={"col-sm-auto shadow " + (selectedPage === "projects" ? "selected" : "notselected")}>
					<a href="/projects">Projects</a>
				</div>
				<div className='col blankheader'></div>
			</div>
		);
	}
}

export default Menu;
